import { i18n } from '@/utils/i18n';

export const columns = {
    id: {
        show: true,
        title: "№",
        sortable: true,
        column: 'id'
    },

    hospitalPatient: {
        show: true,
        title: i18n.t('message.room'),
        class: i18n.t('message.class'),
        floor: i18n.t('message.floor'),
        corps: i18n.t('message.corps'),
        sortable: true,
        column: 'hospitalRoom'
    },
    corps_id: {
        show: true,
        title: i18n.t('message.corps'),
        sortable: true,
        column: 'corps_id'
    },
    class_id: {
        show: true,
        title: i18n.t('message.class'),
        sortable: true,
        column: 'classs_id'
    },
    floor_id: {
        show: true,
        title: i18n.t('message.floor'),
        sortable: true,
        column: 'floor_id'
    },
    created_at: {
        show: true,
        title: i18n.t('message.date'),
        sortable: true,
        column: 'created_at'
    },
    updated_at: {
        show: false,
        title: i18n.t('message.update_date'),
        sortable: true,
        column: 'updated_at'
    },
    settings: {
        show: true,
        title: i18n.t('message.settings'),
        sortable: false,
        column: 'settings'
    }
};
